export default __webpack_public_path__ + "static/media/Sid.46ad851f.jpg";